<template>
  <div id="app" class="relative flex flex-col h-full min-h-screen antialiased bg-gray-50 text-slate-700">
    <MainHeader />
    <div class="flex-1">
      <router-view @set-page-meta="setPageMeta" @load-font="loadFont" @load-all-font="loadAllFont" />
    </div>
    <MainFooter />

    <!-- Floating Action Buttons -->
    <div class="fixed z-40 flex flex-col gap-3 bottom-6 right-4 md:bottom-10 md:right-10 print:hidden">
      <!-- Progress -->
      <router-link to="/progress"
        class="flex items-center gap-2 bg-white text-brand-darkBlue px-5 py-3 rounded-full shadow-[0_4px_12px_rgba(0,0,0,0.1)] border border-brand-darkBlue hover:shadow-[0_6px_16px_rgba(0,0,0,0.15)] hover:scale-105 transition-all duration-300">
        <i data-lucide="monitor-play" class="w-5 h-5 text-brand-blue"></i>
        <span class="font-bold tracking-wide">看診進度</span>
      </router-link>

      <!-- Appointment -->
      <a :href="$store.getters.getThemeColumn('company_line')" target="_blank"
        class="flex items-center gap-2 bg-brand-orange text-white px-5 py-3 rounded-full shadow-[0_4px_12px_rgba(255,140,97,0.4)] hover:shadow-[0_6px_16px_rgba(255,140,97,0.5)] hover:bg-[#FF7A45] hover:scale-105 transition-all duration-300">
        <i data-lucide="phone-call" class="w-5 h-5"></i>
        <span class="font-bold tracking-wide">預約掛號</span>
      </a>
    </div>

    <MainLoading />
  </div>
</template>

<style src="@/assets/css/output.css"></style>

<script>
import { GetMetaData } from "./tools/pageMeta";
import { loadFont } from "@/tools/loadFont";
import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";
import MainLoading from "@/components/MainLoading.vue";
export default {
  name: "App",
  components: {
    MainHeader,
    MainFooter,
    MainLoading,
  },
  data() {
    return {
      meta_data: null,
      loadFontTool: null,
    };
  },
  methods: {
    setPageMeta(page_title, meta_data = { title: "", content: "", image: "" }) {
      this.meta_data = GetMetaData(page_title, meta_data);
    },
    loadFont() {
      this.loadFontTool.checkFontLoad();
    },
    loadAllFont() {
      this.loadFontTool.loadAllFont();
    },
  },
  watch: {
    $route: {
      handler(to) {
        // 因為關閉了預設發送，所以第一次載入也要由這裡觸發，故使用 immediate
        if (typeof window.gtag !== 'undefined') {
          window.gtag('event', 'page_view', {
            page_title: document.title,
            page_location: window.location.href,
            page_path: to.fullPath
          });
        }
      },
      immediate: true // 重要：確保第一次進入也會記錄
    }
  },
  created() {
    this.loadFontTool = new loadFont();
    this.$store.dispatch("getBasePageData");
  },
  metaInfo() {
    return this.meta_data;
  },
};
</script>
